import * as Sentry from '@sentry/vue';
import { IXKTDefaultDataSource } from '@xeokit/xeokit-sdk';
import { utils } from '@xeokit/xeokit-sdk/src/index.js';
import { XKTDefaultDataSource } from '@xeokit/xeokit-sdk/src/plugins/XKTLoaderPlugin/XKTDefaultDataSource.js';

export class DataSourceXKT extends XKTDefaultDataSource implements IXKTDefaultDataSource {
  cacheBuster: boolean = false;

  constructor(cfg: any = {}) {
    super(cfg);
    this.cacheBuster = cfg.cacheBuster !== false;
  }

  _cacheBusterURL(url) {
    if (!this.cacheBuster) {
      return url;
    }
    const timestamp = new Date().getTime();
    if (url.indexOf('?') > -1) {
      return url + '&_=' + timestamp;
    } else {
      return url + '?_=' + timestamp;
    }
  }

  // Gets metamodel JSON
  getMetaModel(metaModelSrc, ok, error) {
    console.log(`XeoXKTDataSource#getMetaModel(${metaModelSrc})`);

    utils.loadJSON(
      metaModelSrc,
      (json) => {
        ok(json);
      },
      function (errMsg) {
        error(errMsg);
      },
    );
  }

  // Gets the contents of the given .XKT file in an arraybuffer
  getXKT(src: string | number, ok: (buffer: ArrayBuffer) => void, error: (e: Error) => void) {
    const defaultCallback = () => {};
    ok = ok || defaultCallback;
    error = error || defaultCallback;

    const processesStore = useProcessesStore();
    const config = useRuntimeConfig();

    const dataUriRegex = /^data:(.*?)(;base64)?,(.*)$/;
    const dataUriRegexResult = (src as string).match(dataUriRegex);

    if (dataUriRegexResult) {
      // Safari can't handle data URIs through XMLHttpRequest
      const isBase64 = !!dataUriRegexResult[2];
      let data = dataUriRegexResult[3];
      data = window.decodeURIComponent(data);
      if (isBase64) {
        data = window.atob(data);
      }
      try {
        const buffer = new ArrayBuffer(data.length);
        const view = new Uint8Array(buffer);
        for (let i = 0; i < data.length; i++) {
          view[i] = data.charCodeAt(i);
        }
        ok(buffer);
      } catch (errMsg: any) {
        Sentry.captureException(error, {
          fingerprint: ['data-source-xkt', 'getXKT', src as string],
        });
        error(errMsg);
      }
    } else {
      const request = new CachedXHR(config.public.URL_EXP_TIME * 1000);
      request.open('GET', this._cacheBusterURL(src), true);

      request.onprogress = function (event: ProgressEvent) {
        if (event.lengthComputable) {
          processesStore.updateDownloadProgress(src as string, event.loaded, event.total);
        }
      };

      request.onabort = function (event: ProgressEvent) {
        const error = new Error('Download aborted');
        processesStore.updateDownloadProgress(src as string, event.loaded, event.total, error);
      };

      request.ontimeout = function (event: ProgressEvent) {
        const error = new Error('Download timeout');
        processesStore.updateDownloadProgress(src as string, event.loaded, event.total, error);
      };

      request.onreadystatechange = function () {
        if (request.readyState === 4) {
          if (request.status !== 200) {
            error(new Error(request.statusText));
          }
        }
      };

      request.addEventListener('finish', async (event: Event) => {
        const blob = (event as CustomEvent).detail as Blob;
        ok(await blob.arrayBuffer());
      });

      request.send(null);
    }
  }
}
